import { parseISO } from "date-fns";
import { z } from "zod";

const ProfileSchema = z.object({
  id: z.string(),
  createdAt: z.date(),
  modifiedAt: z.date(),
  userId: z.string(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  displayName: z.string().nullable(),
  profileImageSrc: z.string().nullable(),
  gender: z.string().nullable(),
  bio: z.string().nullable(),
  deletedAt: z.date().nullable(),
  createdBy: z.string().nullable(),
});

const ProfileDtoSchema = z.object({
  id: z.string(),
  created_at: z.string(),
  modified_at: z.string(),
  user_id: z.string(),
  first_name: z.string().nullable(),
  last_name: z.string().nullable(),
  display_name: z.string().nullable(),
  profile_image_src: z.string().nullable(),
  gender: z.string().nullable(),
  bio: z.string().nullable(),
  deleted_at: z.string().nullable(),
  created_by: z.string().nullable(),
});

export type ProfileDto = z.infer<typeof ProfileDtoSchema>;
export type Profile = z.infer<typeof ProfileSchema>;

export function fromProfileDtoToProfile(dto: ProfileDto): Profile {
  const profileDto = ProfileDtoSchema.parse(dto);
  return ProfileSchema.parse({
    id: profileDto.id,
    createdAt: parseISO(profileDto.created_at),
    modifiedAt: parseISO(profileDto.modified_at),
    userId: profileDto.user_id,
    firstName: profileDto.first_name,
    lastName: profileDto.last_name,
    displayName: profileDto.display_name,
    profileImageSrc: profileDto.profile_image_src,
    gender: profileDto.gender,
    bio: profileDto.bio,
    deletedAt: profileDto.deleted_at ? parseISO(profileDto.deleted_at) : null,
    createdBy: profileDto.created_by,
  });
}
